import styled from "@emotion/styled";
import React, { useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  TextField,
  Alert,
} from "@mui/material";
import { useSelector } from "react-redux";

const Wrapper = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #f5f7fa;
  padding: 20px;
`;

function Deposit() {
  const { user } = useSelector((state) => state.user);
  const [amount, setAmount] = useState("");

  const handleDeposit = (e) => {
    e.preventDefault();

    if (!amount || amount < 100) {
      alert("Minimum deposit is 100");
      return;
    }

    const phoneNumber = "6285217948225";

    const userName = user?.name || user?.username || "Guest";
    const userId = user?._id || user?.id || "N/A";

    const message = `📥 New Deposit Request

👤 User: ${userName}
🆔 ID: ${userId}

💰 Amount: ₹${amount}

📌 Please payment.`;

    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    window.open(url, "_blank");
  };

  return (
    <Wrapper>
      <Card
        sx={{
          width: "100%",
          maxWidth: 420,
          borderRadius: 4,
          boxShadow: 6,
          padding: 2,
        }}
      >
        <CardContent>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Deposit Money
          </Typography>

          <form onSubmit={handleDeposit}>
            <TextField
              fullWidth
              label="Deposit Amount"
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              margin="normal"
              required
              placeholder="Min ₹100"
            />

            <Alert severity="info" sx={{ mt: 2, fontSize: 12 }}>
              Payment करने के बाद WhatsApp पर screenshot भेजें।
            </Alert>

            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              sx={{
                mt: 3,
                borderRadius: 2,
                py: 1.5,
                fontSize: 16,
                fontWeight: 700,
                backgroundColor: "#25D366",
                "&:hover": { backgroundColor: "#1ebe57" },
              }}
            >
              Deposit via WhatsApp
            </Button>
          </form>
        </CardContent>
      </Card>
    </Wrapper>
  );
}

export default Deposit;
